import React from 'react';
import { User } from '../types';
import { Shield, UserCheck, Briefcase, PlusCircle, LogIn, LogOut } from 'lucide-react';

interface NavbarProps {
  user: User | null;
  activeTab: 'jobs' | 'my-applications' | 'hiring-dashboard';
  setActiveTab: (tab: 'jobs' | 'my-applications' | 'hiring-dashboard') => void;
  onOpenAuthModal: () => void;
  onOpenCreateJobModal: () => void;
  onLogout: () => void;
}

export const Navbar: React.FC<NavbarProps> = ({
  user,
  activeTab,
  setActiveTab,
  onOpenAuthModal,
  onOpenCreateJobModal,
  onLogout,
}) => {
  const isHiringTeam = user?.role === 'hiring_team' || user?.role === 'admin';

  return (
    <nav className="navbar">
      <div className="container nav-container">
        <a href="/" className="brand-logo" onClick={(e) => { e.preventDefault(); setActiveTab('jobs'); }}>
          <div className="brand-icon">
            <Briefcase size={22} />
          </div>
          <div>
            <div style={{ lineHeight: 1.1 }}>
              SansCraft <span className="gradient-text">Careers</span>
            </div>
            <span style={{ fontSize: '0.7rem', color: 'var(--text-dim)', fontFamily: 'var(--font-mono)' }}>
              careers.sanscraft.top
            </span>
          </div>
        </a>

        <div className="nav-links">
          <button
            className={`nav-item ${activeTab === 'jobs' ? 'active' : ''}`}
            onClick={() => setActiveTab('jobs')}
          >
            <Briefcase size={16} />
            Explore Openings
          </button>

          {user && (
            <button
              className={`nav-item ${activeTab === 'my-applications' ? 'active' : ''}`}
              onClick={() => setActiveTab('my-applications')}
            >
              <UserCheck size={16} />
              My Applications
            </button>
          )}

          {user && isHiringTeam && (
            <button
              className={`nav-item ${activeTab === 'hiring-dashboard' ? 'active' : ''}`}
              onClick={() => setActiveTab('hiring-dashboard')}
            >
              <Shield size={16} />
              Hiring Portal
            </button>
          )}

          {user && isHiringTeam && (
            <button className="btn-primary" onClick={onOpenCreateJobModal}>
              <PlusCircle size={16} />
              Post New Job
            </button>
          )}

          {/* User Account Info */}
          {user ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginLeft: '12px' }}>
              <span className={`role-badge ${user.role}`}>
                {user.role === 'hiring_team' ? 'HR Team' : 'Applicant'}
              </span>
              
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <span style={{ fontSize: '0.85rem', fontWeight: 700, color: 'var(--text-main)' }}>
                  {user.name}
                </span>
                <span style={{ fontSize: '0.75rem', color: 'var(--text-dim)' }}>
                  {user.email}
                </span>
              </div>

              <button className="btn-secondary" style={{ padding: '8px 12px' }} onClick={onLogout} title="Log Out">
                <LogOut size={16} />
              </button>
            </div>
          ) : (
            <button className="btn-primary" onClick={onOpenAuthModal}>
              <LogIn size={16} />
              Sign In / Register
            </button>
          )}
        </div>
      </div>
    </nav>
  );
};
